import { EAccrualPolicyType } from "./types";

export const getAccrualPolicyTypeLabel = (type: EAccrualPolicyType) => {
  switch (type) {
    case EAccrualPolicyType.PTO:
      return "PTO";
    case EAccrualPolicyType.SICK_LEAVE:
      return "Sick Leave";
    case EAccrualPolicyType.CUSTOM:
      return "Custom";
    default:
      return undefined;
  }
};
